import { CloudCommandsDropDownOptionsDataInterface } from './types';

export const REMOVE_OPTION_FOR_CLOUDS = ['azure', 'oci'];

export const adaptSubscriptionsToCloudCommandDropdownOptions = (
  subscriptionsListFromResponse,
) => {
  let dropDownOptions: CloudCommandsDropDownOptionsDataInterface = {};

  if (subscriptionsListFromResponse?.length > 0) {
    dropDownOptions.subscriptionOptions =
      subscriptionsListFromResponse
        ?.filter((_sub) => _sub?.name)
        ?.map((subscription) => {
          return { label: subscription?.name, id: subscription?._id };
        }) || [];

    let subToCloudOptionsMap = {};

    subscriptionsListFromResponse?.forEach((sub) => {
      const associatedClouds = Object.keys(
        sub?.infraInfo?.associatedClouds,
      )?.filter((_cloud) => !REMOVE_OPTION_FOR_CLOUDS.includes(_cloud));

      subToCloudOptionsMap[sub?.name] = associatedClouds?.map((cloud) => {
        const id = sub?.infraInfo?.associatedClouds[cloud]?.[0]?.cloudAccountId;
        return { cloudAccountId: id, cloud: cloud };
      });
    });

    dropDownOptions.subscriptionToCloudMap = subToCloudOptionsMap;

    let cloudAccountIdToRegionsMap = {};
    subscriptionsListFromResponse?.forEach((_subsctiption) => {
      const clouds = Object?.keys(
        _subsctiption?.infraInfo?.associatedClouds,
      )?.filter((_cloud) => !REMOVE_OPTION_FOR_CLOUDS.includes(_cloud));

      clouds?.forEach((cloudType) => {
        const id =
          _subsctiption?.infraInfo?.associatedClouds?.[cloudType]?.[0]
            ?.cloudAccountId;
        const regions =
          _subsctiption?.infraInfo?.associatedClouds?.[cloudType]?.[0]?.regions;
        cloudAccountIdToRegionsMap[id] = regions;
      });
    });

    dropDownOptions.cloudAccountIdToRegionsMap = cloudAccountIdToRegionsMap;
  }
  return dropDownOptions;
};
